import Col from '@loggi/ui/components/col';
import Text from '@loggi/ui/components/text';
import Icon from '@loggi/ui/components/icon';
import icons from '@loggi/ui/components/utils/icons';
import PropTypes from 'prop-types';
import React from 'react';
import { DELIVERY_LOCATION_MAP } from './confirm-delivery.constants';

export default function RecipientInfo({ receivedBy }) {
  return (
    <Col>
      <Col className="delivery-info-ico">
        <Icon type={icons.type.USER} />
        <Text>{DELIVERY_LOCATION_MAP.RECIPIENT.text}</Text>
      </Col>
      <Col className="delivery-data">
        <Text>{receivedBy}</Text>
      </Col>
    </Col>
  );
}

RecipientInfo.displayName = 'RecipientInfo';

RecipientInfo.propTypes = {
  receivedBy: PropTypes.string.isRequired
};
